export type TDevice = 'mobile' | 'tablet' | 'desktop';

/**
 * Device state interface
 */
export interface DeviceState {
    /**
     * Calculated device type based on screen resolution
     */
    calculatedDeviceType?: TDevice | null;
    /**
     * User agent string
     */
    userAgent?: string;
    /**
     * Screen width
     */
    screenW?: number;
    /**
     * Screen height
     */
    screenH?: number;
}

/**
 * Initial device state
 */
export const initialDeviceState: DeviceState = {};